<h3>{{title}}</h3>
<form [formGroup]="addDiscountForm" (ngSubmit)="onSubmit()"  *ngIf="!confirm">
  <mat-form-field appearance="outline">
    <mat-label>Code promo</mat-label>
    <input matInput type="text" formControlName="promoCodeName">
  </mat-form-field>

 <mat-form-field appearance="outline">
  <mat-label>N° Club</mat-label>
  <mat-select formControlName="clubCode">
    <mat-option *ngFor="let c of clubs" [value]="c"> <strong>{{c.clubCode}}</strong> - {{c.clubName}}</mat-option>
  </mat-select>
</mat-form-field>

<mat-slide-toggle formControlName="withPercentage" [color]="color" class="slideToggle">
  <i>{{addDiscountForm.value.withPercentage ? 'Avec un pourcentage' : 'Avec un montant fixe'}}</i>
</mat-slide-toggle>

 <mat-form-field appearance="outline" *ngIf="!addDiscountForm.value.withPercentage">
  <mat-label>Montant</mat-label>
  <input matInput type="number" formControlName="promoAmount">
</mat-form-field>

<mat-form-field appearance="outline" *ngIf="addDiscountForm.value.withPercentage">
  <mat-label>Pourcentage</mat-label>
  <input matInput type="number" formControlName="promoPercentage">
</mat-form-field>

  <div class="date">
    <mat-form-field appearance="outline">
      <mat-label>Date de début</mat-label>
      <input matInput [matDatepicker]="startDate" formControlName="promoStartDate">
      <mat-datepicker-toggle matSuffix [for]="startDate" ></mat-datepicker-toggle>
      <mat-datepicker #startDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Débute à: </mat-label>
      <input matInput type="time" formControlName="promoStartTime">
  </mat-form-field>

  </div>
 <div class="date">
    <mat-form-field appearance="outline">
      <mat-label>Date de fin</mat-label>
      <input matInput [matDatepicker]="endDate" formControlName="promoEndDate" [min]="getDateLimit('end')">
      <mat-datepicker-toggle matSuffix [for]="endDate" ></mat-datepicker-toggle>
      <mat-datepicker #endDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Se termine:</mat-label>
      <input matInput type="time" formControlName="promoEndTime">
  </mat-form-field>
 </div>
  <div class="btn_action">
    <button class="back" type="button" (click)="closeDialog()">Annuler</button>
    <button [ngClass]="{not_confirm: addDiscountForm.invalid, confirm: addDiscountForm.valid}" type="submit"
      [disabled]="addDiscountForm.invalid" appChangeColorTheme attribute="bgc" >{{btnConfirm}}</button>
  </div>

</form>

<app-validation-animation [text]="text" *ngIf="confirm" ></app-validation-animation>

